import { z } from 'zod';
import { IdSchema } from './encoding.js';
/**
 * Project master contracts (ERD §4.2; FRD-CORE-006, FRD-CRM-033, CRM-034; D3). A business and
 * financial tracking master: code, name, description, the client where applicable, and status. No
 * tasks, milestones, planning or resources (FRD-CRM-034).
 *
 * The code is supplied by the business and unique (ERD §4.2 "Code unique"), in the same form as
 * the other user-entered master codes.
 */
const ProjectCodeSchema = z
    .string()
    .regex(/^[A-Z][A-Z0-9_-]{0,19}$/, 'must be upper case, starting with a letter, up to 20 characters');
const MasterStatusSchema = z.enum(['active', 'inactive']);
export const ProjectSchema = z.object({
    id: IdSchema,
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    /** The client the project is associated with, where applicable (ERD §4.2 "→ Client (0..1)"). */
    clientId: IdSchema.nullable(),
    /** The client's ID and company name, as the CRM module labels it; null when none is named. */
    clientLabel: z.string().nullable(),
    status: MasterStatusSchema,
    /** For `If-Match` on a change (SDD §7.3). */
    version: z.number().int(),
});
export const CreateProjectRequestSchema = z.strictObject({
    code: ProjectCodeSchema,
    name: z.string().trim().min(1).max(200),
    description: z.string().trim().min(1).max(4000).optional(),
    clientId: IdSchema.optional(),
});
/** A partial change; `null` clears the description or the client. The code never changes. */
export const UpdateProjectRequestSchema = z.strictObject({
    name: z.string().trim().min(1).max(200).optional(),
    description: z.string().trim().min(1).max(4000).nullable().optional(),
    clientId: IdSchema.nullable().optional(),
    status: MasterStatusSchema.optional(),
});
//# sourceMappingURL=projects.js.map